import React from 'react';
import { cn } from '../../lib/utils';

const IconLocation = ({
  className,
  ...rest
}: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={cn('flex-shrink-0 fill-current', className)}
      {...rest}
    >
      <mask
        id='mask0_576_3444'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='0'
        y='0'
        width='20'
        height='20'
      >
        <rect width='20' height='20' fill='currentColor' />
      </mask>
      <g mask='url(#mask0_576_3444)'>
        <path
          d='M10.0023 10.0415C10.4728 10.0415 10.8747 9.87398 11.208 9.53892C11.5413 9.20387 11.708 8.80109 11.708 8.33059C11.708 7.86009 11.5405 7.45817 11.2054 7.12484C10.8704 6.7915 10.4676 6.62484 9.99709 6.62484C9.52659 6.62484 9.12467 6.79237 8.79134 7.12742C8.45801 7.46248 8.29134 7.86526 8.29134 8.33576C8.29134 8.80626 8.45887 9.20817 8.79392 9.5415C9.12898 9.87484 9.53176 10.0415 10.0023 10.0415ZM9.99967 15.9998C11.6802 14.4582 12.9198 13.0644 13.7184 11.8186C14.517 10.5728 14.9163 9.46653 14.9163 8.49984C14.9163 6.98595 14.4441 5.76025 13.4997 4.82275C12.5552 3.88525 11.3886 3.4165 9.99967 3.4165C8.61079 3.4165 7.44412 3.88525 6.49967 4.82275C5.55523 5.76025 5.08301 6.98595 5.08301 8.49984C5.08301 9.46653 5.48231 10.5728 6.28092 11.8186C7.07954 13.0644 8.31912 14.4582 9.99967 15.9998ZM9.99967 18.3332C7.76356 16.4026 6.09342 14.6318 4.98926 13.0207C3.88509 11.4096 3.33301 9.90401 3.33301 8.504C3.33301 6.404 3.99967 4.73942 5.33301 3.51025C6.66634 2.28109 8.2219 1.6665 9.99967 1.6665C11.7775 1.6665 13.333 2.28109 14.6663 3.51025C15.9997 4.73942 16.6663 6.404 16.6663 8.504C16.6663 9.90401 16.1143 11.4096 15.0101 13.0207C13.9059 14.6318 12.2358 16.4026 9.99967 18.3332Z'
          fill='currentColor'
        />
      </g>
    </svg>
  );
};

export default IconLocation;
